<div class="dialogContainer">
  <div class="messageWrapper">
    @if (errorMessage) {
      <div class="errorMessage">
        {{ errorMessage }}
      </div>
    }
  </div>
  <div class="content">
    <div class="inputRow">
      <mat-form-field class="inputField">
        <mat-label>Quantity</mat-label>
        <input matInput type="number" [(ngModel)]="newSchedule.quantity"/>
      </mat-form-field>
    </div>
    <div class="inputRow">
      <mat-form-field class="inputField">
        <mat-label>Requested Ship Date</mat-label>
        <input matInput [matDatepicker]="scheduleDatePicker" name="scheduleDateInput" [(ngModel)]="scheduleDate"/>
        <mat-datepicker-toggle matSuffix [for]="scheduleDatePicker"></mat-datepicker-toggle>
        <mat-datepicker id="scheduleDatePicker" #scheduleDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="inputRow">
      <mat-form-field class="inputField">
        <mat-label>Comments</mat-label>
        <textarea rows="3" matInput class="inputTextArea" [(ngModel)]="newSchedule.externalNotes"></textarea>
      </mat-form-field>
    </div>
    <div class="buttonRow">
      <span class="spacer"></span>
      <button (click)="cancel()" matButton="elevated" class="inputButton warn-button">
        <span>
          <mat-icon class="size-16">cancel</mat-icon>
          <label class="buttonLabel">Cancel</label>
        </span>
      </button>
      <button (click)="save()" matButton="elevated" class="inputButton primary-button">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <label class="buttonLabel">OK</label>
        </span>
      </button>
    </div>
  </div>
</div>
